/* eslint-disable no-shadow, no-return-assign */

// @ts-ignore - history module lacks TypeScript definitions
import createHistory from 'history/createBrowserHistory';

import { NAVIGATION_METHODS } from '@ezugi/constants/navigationMethods';
import { URL } from '@ezugi/constants/urls';

let history: any;

const isHandheld = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

export function getHistory(): any {
  return history || (history = createHistory());
}

export function setHistory(h: any): void {
  history = h;
}

/* TODO: SPA - change nav method */
let navigateFunction: ((to: string, options?: Record<string, unknown>) => void) | undefined;

export const setNavigate = (navFn: ((to: string, options?: Record<string, unknown>) => void) | undefined): void => {
  navigateFunction = navFn;
};

export const navigateTo = (to: string, options: Record<string, unknown> = {}): void => {
  if (!navigateFunction) {
    // eslint-disable-next-line no-console
    console.warn('Navigate function not set yet!');
    (window.location as any) = to;
    return;
  }

  navigateFunction(to, options);
};

export function openTab(url: string): void {
  window.open(url, '_blank');
}

export function openPopup(url: string, { width, height }: { width?: number; height?: number }): void {
  // get popup size from options if exist, else make it match screen size
  const size = {
    width: width || window.innerWidth,
    height: height || window.innerHeight,
  };

  // handle dual screens
  const dualScreenLeft = window.screenX !== undefined ? window.screenX : (screen as any).left || 0;
  const dualScreenTop = window.screenY !== undefined ? window.screenY : (screen as any).top || 0;

  // set size for popup
  const popupWidth = Math.min(size.width, window.innerWidth);
  const popupHeight = Math.min(size.height, window.innerHeight);

  // set position of popup
  const popupLeft = dualScreenLeft + (window.innerWidth - popupWidth) / 2;
  const popupTop = dualScreenTop + (window.innerHeight - popupHeight) / 2;

  // set popup size
  const popupOptions = `height=${popupHeight},width=${popupWidth}`;
  const popupWindow = window.open(url, '_blank', popupOptions);

  // make sure popup was created and not blocked before manipulating window
  if (popupWindow) {
    popupWindow.moveTo(popupLeft, popupTop);
    popupWindow.focus();
  } else {
    // warn that popup was not created
    throw new Error('Popup was blocked');
  }
}

export function historyPush(url: string) {
  navigateTo(url, { viewTransition: true });
}

export function navigate(
  method: string | undefined,
  url: string,
  options: { queryString?: string; width?: number; height?: number; outerLink?: boolean } = {},
): void {
  const baseUrl = method === NAVIGATION_METHODS.LOBBY ? URL.LOBBY : url ?? '';
  const _url = options.queryString
    ? baseUrl.concat(baseUrl.indexOf('?') === -1 ? '?' : '&').concat(options.queryString)
    : baseUrl;

  if (options.outerLink) {
    window.location.href = _url;
  } else
    if (
      method === NAVIGATION_METHODS.LOBBY
    || method === NAVIGATION_METHODS.URL
    || method === NAVIGATION_METHODS.REPLACE
    || (method === NAVIGATION_METHODS.POPUP && !!window.opener)
    ) {
      historyPush(_url);
    } else if (method === NAVIGATION_METHODS.TAB) {
      openTab(_url);
    } else if (method === NAVIGATION_METHODS.POPUP) {
      isHandheld() ? openTab(_url) : openPopup(_url, options);
    } else {
      throw new Error('No navigation method provided');
    }
}
